<template lang="pug">
page(
    main-title="Скидки, наценки, изменение сроков",
    :main-description="`${mode.text} правила расчёта стоимости и срока доставки`",
    :links="[{component: 'CostRules', title: 'Скидки и наценки'}, mode.text]"
)
    .panel
        .panel-body
            .checkbox.clip-check.check-primary
                input#is_active(type="checkbox", v-model="rule.active")
                label(for="is_active") Правило включено
            .checkbox.clip-check.check-primary
                input#change_price_input(
                    type="checkbox",
                    v-model="changePrice"
                )
                label(for="change_price_input") Правило изменяет <b>стоимость</b> доставки

            template(v-if="changePrice")
                p.margin-top-20.margin-bottom-10 Тут необходимо выбрать
                    <b>тип</b> правила и его <b>численное значение</b>
                    | :
                .row
                    .col-md-8
                        .radio.clip-radio.radio-primary.radio-inline
                            input#math_sign_minus(type="radio",
                                                  v-model="rule.math_sign",
                                                  value="-")
                            label(for="math_sign_minus") Скидка
                        .radio.clip-radio.radio-primary.radio-inline
                            input#math_sign_plus(type="radio",
                                                 v-model="rule.math_sign",
                                                 value="+")
                            label(for="math_sign_plus") Наценка
                        .radio.clip-radio.radio-primary.radio-inline
                            input#math_sign_fix(type="radio",
                                                v-model="rule.math_sign",
                                                value="fix_price")
                            label(for="math_sign_fix") Фиксированная стоимость
                        .radio.clip-radio.radio-primary.radio-inline
                            input#math_sign_round(type="radio",
                                                v-model="rule.math_sign",
                                                value="round")
                            label(for="math_sign_round") Округление до
                    template(v-if="rule.math_sign != 'round'")
                        .col-md-2
                            .form-group(:class="{'has-error': validation.math_value}")
                                .vfl-field.input-group(style='width: 100%;')
                                    input(required="",
                                          type="text",
                                          class="decimal-field",
                                          v-model="rule.math_value")
                                    span.field-underline
                                    label Значение
                                span.help-block.error(v-if="validation.math_value") {{ validation.math_value }}
                        .col-md-2
                            .radio.clip-radio.radio-primary.radio-inline
                                input#math_value_dimension_fix(type="radio",
                                                               v-model="rule.math_value_dimension",
                                                               value="rub")
                                label(for="math_value_dimension_fix") Руб.
                            .radio.clip-radio.radio-primary.radio-inline
                                input#math_value_dimension_percent(type="radio",
                                                               v-model="rule.math_value_dimension",
                                                               value="%")
                                label(for="math_value_dimension_percent") %
                    template(v-else)
                        .col-md-4(style="height: 48px;")
                            .radio.clip-radio.radio-primary.radio-inline
                                input#math_value_round_10(type="radio",
                                                          name="math_value_round",
                                                          v-model="rule.math_value",
                                                          :value="10")
                                label(for="math_value_round_10") 10 руб.
                            .radio.clip-radio.radio-primary.radio-inline
                                input#math_value_round_50(type="radio",
                                                          name="math_value_round",
                                                          v-model="rule.math_value",
                                                          :value="50")
                                label(for="math_value_round_50") 50 руб.
                            .radio.clip-radio.radio-primary.radio-inline
                                input#math_value_round_100(type="radio",
                                                           name="math_value_round",
                                                           v-model="rule.math_value",
                                                           :value="100")
                                label(for="math_value_round_100") 100 руб.
            hr
            .checkbox.clip-check.check-primary
                input#change_days_input(
                    type="checkbox",
                    v-model="changeDays"
                )
                label(for="change_days_input") Правило изменяет <b>срок</b> доставки
            .row(v-if="changeDays")
                .col-md-6
                    .form-group(:class="{'has-error': validation.plus_delivery_days}")
                        .vfl-field.input-group(style='width: 100%;')
                            input(required="",
                                  type="text",
                                  class="integer-field",
                                  v-model="rule.plus_delivery_days")
                            span.field-underline
                            label Увеличить на <i>n</i> дней
                        span.help-block.error(v-if="validation.plus_delivery_days") {{ validation.plus_delivery_days }}

            .checkbox.clip-check.check-primary
                input#disable_delivery_methods(
                    type="checkbox",
                    v-model="rule.disable_delivery_methods"
                )
                label(for="disable_delivery_methods") Правило блокирует указанные <b>службы доставки</b> (они не будут выводиться для заказов, подходящих под правило)
            .row(v-if="rule.disable_delivery_methods")
                .col-md-12.margin-bottom-10
                    span Если после применении данного правила не останется <b>ни одного</b> способа доставки,
                        | можно вывести информационное сообщение (вместо стандартного
                        | <i>«Доставка в Ваш город не осуществляется»</i>, например,
                        | <i>«Доставка осуществляется при заказе от 1 000 руб.»</i>):
                .col-md-12
                    .form-group
                        .vfl-field.input-group(style='width: 100%;')
                            input(required="",
                                  type="text",
                                  v-model="rule.block_message")
                            span.field-underline
                            label Информационное сообщение

            hr
            p.margin-top-20.margin-bottom-20 Тут можно выбрать на что будет действовать
                |  данное <code>правило</code>:
            .row
                .col-md-6.border-right
                    .form-group
                        v-select-styled(v-model="rule.regions",
                                        multiple='',
                                        :disabled="disabled.regions",
                                        :on-search="getRegions",
                                        field-label="Регионы"
                                        :options="regions")
                    .form-group
                        v-select-styled(v-model="rule.cities",
                                        multiple='',
                                        :disabled="disabled.cities",
                                        :on-search="getCities",
                                        max-height="350px",
                                        field-label="Населённые пункты"
                                        :options="cities")
                    .form-group
                        v-select-styled(v-model="rule.delivery_methods",
                                        multiple='',
                                        :disabled="disabled.delivery_methods",
                                        :on-search="getDeliveryMethods",
                                        fieldLabel="Способы доставки"
                                        :options="deliveryMethods")
                    .form-group
                        v-select-styled(v-model="rule.pvzs",
                                        multiple='',
                                        :disabled="disabled.pvzs",
                                        :on-search="getPvzs",
                                        fieldLabel="Пункты самовывоза"
                                        :options="pvzs")
                    .form-group
                        v-select-styled(v-model="rule.promocodes",
                                        multiple='',
                                        label='promocode',
                                        :disabled="disabled.promocodes",
                                        :on-search="getPromocodes",
                                        fieldLabel="Промокоды"
                                        :options="promocodes")
                    .form-group
                        v-select-styled(v-model="rule.products",
                                        multiple='',
                                        :disabled="disabled.products",
                                        :on-search="getProducts",
                                        fieldLabel="Продукты"
                                        :options="products")
                .col-md-6
                    .form-group
                        v-select-styled(v-model="rule.regions_exclude",
                                        multiple='',
                                        :disabled="disabled.regions_exclude",
                                        :on-search="getRegions",
                                        field-label="Все регионы, кроме"
                                        :options="regions")
                    .form-group
                        v-select-styled(v-model="rule.cities_exclude",
                                        multiple='',
                                        :disabled="disabled.cities_exclude",
                                        :on-search="getCitiesExclude",
                                        max-height="350px",
                                        field-label="Все населённые пункты, кроме"
                                        :options="cities")
                    .form-group
                        v-select-styled(v-model="rule.delivery_methods_exclude",
                                        multiple='',
                                        :disabled="disabled.delivery_methods_exclude",
                                        :on-search="getDeliveryMethods",
                                        fieldLabel="Все способы доставки, кроме"
                                        :options="deliveryMethods")
                    .form-group
                        v-select-styled(v-model="rule.pvzs_exclude",
                                        multiple='',
                                        :disabled="disabled.pvzs_exclude",
                                        :on-search="getPvzsExclude",
                                        fieldLabel="Все пункты самовывоза, кроме"
                                        :options="pvzs")
                    .form-group
                        v-select-styled(v-model="rule.promocodes_exclude",
                                        multiple='',
                                        label='promocode',
                                        :disabled="disabled.promocodes_exclude",
                                        :on-search="getPromocodes",
                                        fieldLabel="Все промокоды, кроме"
                                        :options="promocodes")
                    .form-group
                        v-select-styled(v-model="rule.products_exclude",
                                        multiple='',
                                        :disabled="disabled.products_exclude",
                                        :on-search="getProducts",
                                        fieldLabel="Все продукты, кроме"
                                        :options="products")
            .row
                .col-md-12
                    .margin-bottom-10
                    .margin-top-20
                        span Можно применять <code>правило</code> только при стоимости заказа <b>выше</b> или <b>ниже</b> определенной суммы

            .row
                .col-md-12
                    .radio.clip-radio.radio-primary.radio-inline.radio-inline-margins
                        input#order_price_from(type="radio",
                                         v-model="rule.order_price_from_to",
                                         :value="true")
                        label(for="order_price_from") Заказы дороже указанной суммы
                    .radio.clip-radio.radio-primary.radio-inline.radio-inline-margins
                        input#order_price_to(type="radio",
                                         v-model="rule.order_price_from_to",
                                         :value="false")
                        label(for="order_price_to") Заказы дешевле указанной суммы

            .row
                .col-md-6
                    .form-group(:class="{'has-error': validation.order_price}")
                        .vfl-field.input-group(style='width: 100%;')
                            input(required="",
                                  type="text",
                                  class="integer-field",
                                  v-model="rule.order_price")
                            span.field-underline
                            label Стоимость заказа (объявленная ценность)
                        span.help-block.error(v-if="validation.order_price") {{ validation.order_price }}

            .row
                .col-md-12
                    .margin-bottom-10
                    .margin-top-20
                        span Можно применять <code>правило</code> только при весе заказа <b>больше</b> или <b>меньше</b> определенного веса

            .row
                .col-md-12
                    .radio.clip-radio.radio-primary.radio-inline.radio-inline-margins
                        input#weight_from(type="radio",
                                         v-model="rule.weight_from_to",
                                         :value="true")
                        label(for="weight_from") Заказы тяжелее указанного веса
                    .radio.clip-radio.radio-primary.radio-inline.radio-inline-margins
                        input#weight_to(type="radio",
                                         v-model="rule.weight_from_to",
                                         :value="false")
                        label(for="weight_to") Заказы легче указанного веса

            .row
                .col-md-6
                    .form-group(:class="{'has-error': validation.order_price}")
                        .vfl-field.input-group(style='width: 100%;')
                            input(required="",
                                  type="text",
                                  class="integer-field",
                                  v-model="rule.weight")
                            span.field-underline
                            label Вес заказа в граммах
                        span.help-block.error(v-if="validation.weight") {{ validation.weight }}

            .row
                .col-md-6
                    .form-group(:class="{'has-error': validation.priority}")
                        .vfl-field.input-group(style='width: 100%;')
                            input(required="",
                                  id="input-priority",
                                  class="integer-field",
                                  type="text",
                                  v-model="rule.priority")
                            span.field-underline
                            label Приоритет правила
                        span.help-block.error(v-if="validation.priority") {{ validation.priority }}
                .col-md-6
                    span.help-block
                        i.ti-help-alt.text-primary
                        |  В случае, если подходит сразу несколько <code>правил</code> будем применяться
                        | <code>правило</code> с б<b>о</b>льшим значением приоритета.
            .row
                .col-md-6
                    .checkbox.clip-check.check-primary.margin-top-0
                        input#apply_lower_priority_rules(
                            type="checkbox",
                            v-model="rule.apply_lower_priority_rules"
                        )
                        label(for="apply_lower_priority_rules")
                            | Применять подходящие <code>правила</code> с меньшим приоритетом
                .col-md-6
                    span.help-block
                        i.ti-help-alt.text-primary
                        |  Если галочка установлена, то после применения данного <code>правила</code> будут
                        | также будут применяться <b>подходящие</b> <code>правила</code> c меньшим приоритетом.

                        //- |  Установите этот параметр, если после применения данного правила могут применяться
                        //- | другие правила с меньшим значением приоритета. В противном случае результат расчёта
                        //- | по данному правилу будет считаться финальным.

            .row
                .col-md-12
                    .margin-top-20.margin-bottom-10
                        span Возможные способы оплаты (выключите, чтобы заблокировать способ оплаты для указанных условий):

            .row
                .col-md-12(v-for="paymentType in ruleDeliveryPaymentTypes")
                    .checkbox.clip-check.check-primary.margin-top-0
                        input(
                            :id='"payment_type_"+paymentType.code',
                            type="checkbox",
                            v-model="paymentType.disabled"
                            :true-value="false"
                            :false-value="true"
                        )
                        label(:for='"payment_type_"+paymentType.code')
                            | {{ paymentType.name }}

            .row
                .col-md-6
                    .form-group(:class="{'has-error': validation.extra_data}")
                        .vfl-field.input-group(style='width: 100%;')
                            input(required="",
                                  id="input-extra_data",
                                  type="text",
                                  v-model="rule.extra_data")
                            span.field-underline
                            label Дополнительное поле
                        span.help-block.error(v-if="validation.extra_data") {{ validation.extra_data }}
                .col-md-6
                    span.help-block
                        i.ti-help-alt.text-primary
                        |  Помогает настраивить <code>правила</code> более гибко.

            button.btn.btn-o.btn-primary(@click.prevent="save") Сохранить
            button.btn.btn-o.btn-danger.margin-left-4(
                v-if="mode.type === 'update'",
                @click.prevent="remove"
            ) Удалить
            button.btn.btn-o.btn-primary.pull-right(@click.prevent="discard") Отмена
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { arrayNotEmpty } from '@/utils/helpers';
import { getAjaxSearchMethod } from '@/utils/vSelect';
import vSelectStyled from '@/components/vSelectStyled';
import { SEARCH_DELIVERY_METHOD } from '@/store/api-points';

import cloneDeep from 'lodash/cloneDeep';
import Inputmask from 'inputmask/dist/inputmask/inputmask';

const getDisabledWatcher = (...args) => {
    let f = (name, parent = false) => {
        return function(val) {
            if (arrayNotEmpty(val)) {
                if (arrayNotEmpty(this.rule[name])) this.rule[name] = [];
                if (parent && arrayNotEmpty(this.rule[parent])) this.rule[parent] = [];
            }
        };
    };

    let res = {};
    args.forEach(([n, p]) => {
        let ne = `${n}_exclude`,
            pe = p ? `${p}_exclude` : false;

        res[`rule.${n}`] = f(ne, pe);
        res[`rule.${ne}`] = f(n, p);
    });
    return res;
};

export default {
    name: 'EditCostRule',
    components: {vSelectStyled},
    mounted() {
        this.createMasks();
    },
    methods: {
        save() {
            // Надо заполнить rule.disabledPaymentTypes отключенными способами оплаты
            let disabledPaymentTypes = [];
            this.ruleDeliveryPaymentTypes.forEach(function(el) {
                if (el.disabled) {
                    disabledPaymentTypes.push(el.code);
                }
            });
            this.rule.disabled_payment_types = disabledPaymentTypes;

            this.$store.dispatch('saveCostRule', {
                costRule: {
                    ...this.rule,
                    change_price: this.changePrice,
                    change_days: this.changeDays
                },
                markInvalid: this.markInvalid
            });
        },
        markInvalid(errors) {
            this.errors = errors;
        },
        clearError(field) {
            let index = this.errors.findIndex((item) => item.field === field);
            this.errors.splice(index, 1);
        },
        remove() {
            this.$store.dispatch('deleteCostRule', this.rule);
        },
        discard() {
            this.$router.push({name: 'CostRules'});
        },
        createMasks() {
            let integerFields = document.getElementsByClassName('integer-field');
            let decimalFields = document.getElementsByClassName('decimal-field');

            Inputmask({regex: '\\-?\\d{0,15}'}).mask(integerFields);
            Inputmask({regex: '\\d{0,15}[.]{1}\\d{0,2}', placeholder: ''}).mask(decimalFields);
        },
        getRegions: getAjaxSearchMethod(
            '/fias/regions/search/',
            'regions'
        ),
        getCities: getAjaxSearchMethod(
            '/fias/cities/search/',
            'cities',
            ['rule.regions', 'rule.regions_exclude']
        ),
        getCitiesExclude: getAjaxSearchMethod(
            '/fias/cities/search/',
            'cities',
            [{value: 'rule.regions_exclude', name: 'regions'},
             {value: 'rule.regions', name: 'regions_exclude'}]
        ),
        getDeliveryMethods: getAjaxSearchMethod(
            SEARCH_DELIVERY_METHOD,
            'deliveryMethods'
        ),
        getPvzs: getAjaxSearchMethod(
            '/tariffs/pvz/search/',
            'pvzs',
            ['rule.delivery_methods', 'rule.delivery_methods_exclude']
        ),
        getPvzsExclude: getAjaxSearchMethod(
            '/tariffs/pvz/search/',
            'pvzs',
            [{value: 'rule.delivery_methods_exclude', name: 'delivery_methods'},
             {value: 'rule.delivery_methods', name: 'delivery_methods_exclude'}]
        ),
        getPromocodes: getAjaxSearchMethod(
            '/cost_rules/promocode/search/',
            'promocodes'
        ),
        getProducts: getAjaxSearchMethod(
            '/products/search/',
            'products'
        )
    },
    computed: {
        ...mapGetters(['deliveryPaymentTypes']),
        mode() {
            return {
                text: this.rule.id ? 'Редактирование' : 'Создание',
                type: this.rule.id ? 'update' : 'create'
            };
        },
        disabled() {
            let w = (...args) => {
                let res = {};
                args.forEach((n) => {
                    res[n] = arrayNotEmpty(this.rule[`${n}_exclude`]);
                    res[`${n}_exclude`] = arrayNotEmpty(this.rule[n]);
                });
                return res;
            };
            return {
                ...w('regions', 'cities', 'delivery_methods', 'pvzs',
                     'promocodes', 'products')
            };
        },
        validation: {
            get() {
                let res = {};
                this.errors && this.errors.forEach((item) => {
                    res[item.field] = item.message;
                });
                return res;
            }
        }
    },
    watch: {
        'rule.priority'(val, prev) {
            if (val && this.validation.priority) this.clearError('priority');

            if (!(val - Math.floor(val))) return;

            this.rule.priority = Math.floor(val);
        },
        'rule.math_value'(val) {
            if (val && this.validation.math_value) this.clearError('math_value');
        },
        'rule.math_sign'(val, prevVal) {
            if (val && val == 'round' && [50, 100].indexOf(this.rule.math_value) === -1) this.rule.math_value = 50;
            else if (prevVal == 'round') this.rule.math_value = null;
        },
        changePrice(val) {
            if (val) this.createMasks();
            else {
                this.rule.math_value = null;
                this.rule.math_sign = '-';
            }
        },
        changeDays(val) {
            if (val) this.createMasks();
            else this.rule.plus_delivery_days = null;
        }
    },
    data() {
        let rule = cloneDeep(this.$store.state.localStorage.editedCostRule);

        if (!rule.math_sign && !rule.math_value_dimension) {
            rule.math_sign = '-';
            rule.math_value_dimension = 'rub',
            rule.active = true;
        }

        let changePrice = true;
        let changeDays = false;
        // let disable_delivery_methods = false
        // Если установлена скидка 0 – скрываем поле с настройками стоимости
        if (rule.id && (['+', '-'].includes(rule.math_sign) && !rule.math_value)) changePrice = false;
        // По умолчанию – не показываем изменение срока доставки
        if (rule.id && rule.plus_delivery_days) changeDays = true;
        if (rule.id && rule.disable_delivery_methods) rule.disable_delivery_methods = true;

        let ruleDeliveryPaymentTypes = [];
        this.$store.state.costRules.deliveryPaymentTypes.forEach((el) => {
            let disabled = false;
            if (rule.disabled_payment_types) {
                rule.disabled_payment_types.forEach(function(disabled_payment_type) {
                    if (disabled_payment_type == el.code) {
                        disabled = true;
                    }
                });
            }

            ruleDeliveryPaymentTypes.push({
                code: el.code,
                name: el.name,
                disabled: disabled
            });
        });

        return {
            rule,

            changePrice,
            changeDays,
            // disable_delivery_methods,

            regions: [],
            cities: [],
            deliveryMethods: [],
            pvzs: [],
            promocodes: [],
            products: [],

            errors: [],

            ruleDeliveryPaymentTypes: ruleDeliveryPaymentTypes
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/costRules/EditCostRule.vue